//Se usa solamente para carga de futuros cm05

import React, { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import InputMask from "react-input-mask";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import {
    Select,
    FormControl,
    MenuItem,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import LocationOnIcon from "@mui/icons-material/LocationOn";

//CUSTOM IMPORTS
import TableHead from "./TableHead";
import { getData } from "../../../../../../../services/library";

export default function Cm05Form({
    inscrIIBB,
    handleInputChange,
    handleInputChangeProvincia,
    handleClickDelBtn,
    editarInscripcion,
    guardarInscripcion,
    IIBBPadrones,
}) {
    const [provincias, setProvincias] = useState();

    useEffect(() => {
        getData("/provincias/all/datos_iibb", setProvincias);
    }, [])

    const inputProps = {
        disableUnderline: true,
        sx: {
            paddingTop: 0,
            paddingBottom: 0,
            height: "32px",
        },
    };

    const inputsx = {
        ".MuiFilledInput-root": {
            paddingTop: 0,
            paddingBottom: 0,
            height: "32px",
        },
        ".MuiInputBase-input": {
            paddingTop: "6px",
            paddingBottom: "6px",
        },
    };

    const columnSizes = {
        provincia: 5,
        inicio: 1,
        fin: 1,
        coeficienteUnificado: 2,
        percepcion: 2,
        acciones: 1,
    }

    const variant = "outlined"

    return (
        <div>
            <TableHead columnSizes={columnSizes} showExclusiones={false} showColPeriodo={false} />
            <Grid item xs={12}>
                {inscrIIBB?.map((field, index) => (
                    <>
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="space-between"
                            p={1}
                            backgroundColor="#fff"
                            mt={1}
                            borderRadius={1}
                            direction="row"
                        >
                            <Grid
                                item
                                xs={columnSizes.provincia}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <LocationOnIcon color="primary" />
                                {provincias && (
                                    <FormControl fullWidth disabled={!!field.id_inscripcion}>
                                        <Select
                                            variant="filled"
                                            size="small"
                                            value={field.id_provincia}
                                            onChange={(e) => {
                                                handleInputChangeProvincia(index, e, provincias, IIBBPadrones)
                                            }}
                                            name="id_provincia"
                                            sx={{
                                                ...inputsx,
                                                height: "32px",
                                                "&:before": {
                                                    borderBottom: "none",
                                                },
                                                "&:hover:not(.Mui-disabled):before": {
                                                    borderBottom: "none",
                                                },
                                                "&:after": {
                                                    borderBottom: "none",
                                                },
                                            }}
                                        >
                                            {provincias.map((provincia) => {
                                                const isDisabled = inscrIIBB.some(
                                                    (item) =>
                                                        item.id_provincia === provincia.id
                                                );

                                                return (
                                                    <MenuItem
                                                        key={provincia.id}
                                                        value={provincia.id}
                                                        disabled={isDisabled}
                                                    >
                                                        {provincia.cod_ddjj} - {provincia.provincia}{" "}
                                                        {provincia.iibb_auto === 1
                                                            ? "(Padrón)"
                                                            : ""}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                )}
                            </Grid>
                            <Grid item xs={columnSizes.coeficienteUnificado}>
                                <InputMask
                                    mask="9.9999"
                                    value={field.coeficiente_unificado}
                                    maskChar="0"
                                    onChange={(e) => handleInputChange(index, e)}
                                    disabled={!field.modoEdicion}
                                >
                                    {() => (
                                        <TextField
                                            disabled={!field.modoEdicion}
                                            error={Number(field.coeficiente_unificado) > 1}
                                            variant={variant}
                                            size="small"
                                            fullWidth
                                            name="coeficiente_unificado"
                                            InputProps={inputProps}
                                            sx={inputsx}
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            {
                                Boolean(field?.impuestoPadron) && !field.percepcion ? (
                                    <Grid item xs={columnSizes.percepcion}>
                                        <TextField
                                            variant={variant}
                                            size="small"
                                            fullWidth
                                            InputProps={inputProps}
                                            sx={{
                                                ...inputsx,
                                                "& .MuiInputBase-input": {
                                                    fontSize: "0.6rem",
                                                },
                                            }}
                                            disabled={!field.modoEdicion}
                                            value={"NO EMPADRONADO"}
                                        />
                                    </Grid>
                                ) : (
                                    <Grid item xs={columnSizes.percepcion}>
                                        <InputMask
                                            mask="9.99"
                                            value={field.percepcion == 0 ? "0.00" : field.percepcion}
                                            maskChar="0"
                                            onChange={(e) => handleInputChange(index, e)}
                                            disabled={!field.modoEdicion || field.deshabilitaPercepcion}
                                        >
                                            {() => (
                                                <TextField
                                                    disabled={!field.modoEdicion || field.deshabilitaPercepcion}
                                                    variant={variant}
                                                    size="small"
                                                    fullWidth
                                                    name="percepcion"
                                                    InputProps={inputProps}
                                                    sx={inputsx}
                                                />
                                            )}
                                        </InputMask>
                                    </Grid>
                                )
                            }
                            <Grid
                                item
                                xs={columnSizes.acciones}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    pr: 3,
                                }}
                            >
                                {field.id_inscripcion && !field.modoEdicion && (
                                    <Tooltip title="Editar">
                                        <IconButton
                                            color="primary"
                                            name="modoEdicion"
                                            onClick={() => {
                                                const event = {
                                                    target: {
                                                        name: "modoEdicion",
                                                        value: true
                                                    }
                                                };
                                                handleInputChange(index, event)
                                            }}
                                        >
                                            <ModeEditIcon />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                {field.modoEdicion && field.id_inscripcion ? (
                                    <Tooltip title="Guardar">
                                        <IconButton
                                            color="success"
                                            name="modoEdicion"
                                            onClick={() => {
                                                const event = {
                                                    target: {
                                                        name: "modoEdicion",
                                                        value: false
                                                    }
                                                };
                                                handleInputChange(index, event)
                                                editarInscripcion(field)
                                            }}
                                        >
                                            <SaveAsIcon />
                                        </IconButton>
                                    </Tooltip>
                                ) : null}
                                {!field.id_inscripcion && (
                                    <Tooltip title="Guardar">
                                        <IconButton
                                            disabled={!field.id_provincia || (Number(field.coeficiente_unificado) <= 0) || (Number(field.coeficiente_unificado) > 1) }
                                            onClick={() => {
                                                guardarInscripcion(field)
                                            }}
                                            color="primary"
                                            sx={{ p: 0.5 }}
                                        >
                                            <SaveIcon />
                                        </IconButton>
                                    </Tooltip>)
                                }
                                <Tooltip title="Eliminar IIBB">
                                    <IconButton
                                        onClick={() => {
                                            handleClickDelBtn(field, index)
                                        }}
                                        color="error"
                                        sx={{ p: 0.5 }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </>
                ))}
            </Grid>
        </div>
    )
}


{/* {index === inscrIIBB.length - 1 && field.id_inscripcion && (
    <Tooltip title="Agregar IIBB">
        <IconButton
            onClick={() => {
                addImpuesto();
                const event = {
                    target: {
                        name: "modoEdicion",
                        value: false
                    }
                };
                handleInputChange(index, event)
            }}
            color="success"
            sx={{ p: 0.5 }}
        >
            <AddCircleOutlineIcon />
        </IconButton>
    </Tooltip>
)} */}